import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import "./assets/css/style.css"

Vue.config.productionTip = false;

router.beforeEach((to, from, next) => {
  if (to.name) {
    document.title = `Max and Christina | ${to.name}`;
  } else {
    document.title = 'Max and Christina';
  }
  next();
});

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
